export const familyListKey = 'descriptions.admin-portal.family.list';
